import format from 'date-fns/format';
import AZ from 'date-fns/locale/az';
import EN from 'date-fns/locale/en-US';
import KZ from 'date-fns/locale/kk';
import RU from 'date-fns/locale/ru';
import UA from 'date-fns/locale/uk';
import UZ from 'date-fns/locale/uz';
import parseISO from 'date-fns/parseISO';

import { Lang } from 'src/types';

const LOCALES = { AZ, EN, KZ, RU, UA, UZ, KG: RU };
const DEFAULT_LANG = (typeof window !== 'undefined' && window.globalVars?.lang) || Lang.RU;
export const DEFAULT_LOCALE = LOCALES[DEFAULT_LANG];

const formatDate = (date: string | number | Date, formatString: string, lang: Lang = DEFAULT_LANG): string =>
    format(typeof date === 'string' ? parseISO(date) : date, formatString, {
        locale: LOCALES[lang],
    });

export default formatDate;
